import React from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../../base/hooks';
import { Area } from '../../../../../../base/interfaces/config';
import { __t } from '../../../../../../base/utils/t';
import { signUpActions } from '../../../redux/slices/signUpSlice';
import { AreasSelect as AreasSelectComponent } from '../../../../../components/AreasSelect';

import '../styles.scss';

export const AreasSelect = () => {
    const dispatch = useAppDispatch();
    const { areas: selectedAreas } = useAppSelector((state) => state.recruiterAppSignUp.fields);
    const { areas } = useAppSelector((state) => state.recruiterApp.config);

    const inputChangeHandler = (id: string, value: unknown) => {
        dispatch(signUpActions.setField({ id, value }));
    };

    return (
        <div className='razem-app__wrapper'>
            <AreasSelectComponent
                title={__t('В какие сферы трудоустраиваете работников?')}
                areas={areas}
                selectedAreas={selectedAreas}
                selectHandler={(value: Area[]) => inputChangeHandler('areas', value)}
            />
        </div>
    );
};
